import FormattedText from './formatted-text'

export type { FormattedTextProps } from './formatted-text'

export default FormattedText
